import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FlowModule} from '@fantasmagames/slot/src/modules/flow/FlowModule';
import {Action} from '@fantasmagames/slot/src/logic/Action';

export class FlowRestoreState extends ModuleState<null, FlowModule> {

	protected setupEvents(): void {
	}

	public onEnterState(): void {
		switch (this.module.logic.nextAction) {
			case Action.FREESPIN: {
				this.restoreFreespins();
				break;
			}

			case Action.RESPIN: {
				this.restoreRespin();
				break;
			}

			case Action.PICK: {
				this.restorePickBonus();
				break;
			}

			case Action.AVALANCHE: {
				this.restoreAvalanche();
				break;
			}

			default:
				this.module.gotoState(FlowModule.BASIC_STATE);
				break;
		}
	}

	public onLeaveState(): void {
	}

	protected restoreFreespins(): void {
	}

	protected restoreRespin(): void {
	}

	protected restorePickBonus(): void {
	}

	protected restoreAvalanche(): void {

	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/flow/states/FlowRestoreState.ts